import { MenuItem } from "@mui/material";
import React, { useEffect, useRef } from "react";
import usePlacesAutocomplete, { getGeocode } from "use-places-autocomplete";
import classes from "./Mapa.module.scss";

const LAT_LNG_REGEX = /^\s*(-?\d{1,3}(?:\.\d+)?)\s*[,\s]+\s*(-?\d{1,3}(?:\.\d+)?)\s*$/;

export default function SearchBox({ onSetCoordenadas, direccion }) {
    const {
        ready,
        value,
        suggestions: { status, data },
        setValue,
        clearSuggestions,
    } = usePlacesAutocomplete({
        requestOptions: {
            componentRestrictions: { country: "ar" },
        },
        debounce: 300,
    });

    useEffect(() => {
        if (direccion) {
            setValue(direccion);
        }
    }, [direccion, setValue]);

    const latLngMatch = value.match(LAT_LNG_REGEX);

    const handleInput = (e) => {
        setValue(e.target.value);
    };

    const handleSelectLatLng = async (lat, lng) => {
        clearSuggestions();
        try {
            const geocoder = new window.google.maps.Geocoder();
            geocoder.geocode({ location: { lat, lng } }, (results, status) => {
                const addressComponents = status === "OK" && results[0]
                    ? results[0].address_components
                    : [];
                const streetName = addressComponents.find(c => c.types.includes("route"))?.long_name || '';
                const streetNumber = addressComponents.find(c => c.types.includes("street_number"))?.long_name || '';
                const postalCode = addressComponents.find(c => c.types.includes("postal_code"))?.long_name || '';
                const city = addressComponents.find(c => c.types.includes("locality"))?.long_name ||
                    addressComponents.find(c => c.types.includes("administrative_area_level_2"))?.long_name ||
                    addressComponents.find(c => c.types.includes("sublocality"))?.long_name || '';

                if (streetName || city) {
                    setValue(`${streetName} ${streetNumber}${city ? `, ${city}` : ''}`.trim(), false);
                }

                onSetCoordenadas({
                    lat,
                    lng,
                    calle: streetName,
                    numero: streetNumber,
                    localidad: city,
                    cod: postalCode,
                });
            });
        } catch (err) {
            console.error("Geocode error:", err);
            onSetCoordenadas({ lat, lng, calle: '', numero: '', localidad: '', cod: '' });
        }
    };

    const handleSelect = ({ description }) => async () => {
        setValue(description, false);
        clearSuggestions();

        const results = await getGeocode({ address: description });
        const addressComponents = results[0].address_components;

        const streetName = addressComponents.find(c => c.types.includes("route"))?.long_name;
        const streetNumber = addressComponents.find(c => c.types.includes("street_number"))?.long_name;
        const postalCode = addressComponents.find(c => c.types.includes("postal_code"))?.long_name;
        const city = addressComponents.find(c => c.types.includes("locality"))?.long_name ||
            addressComponents.find(c => c.types.includes("administrative_area_level_2"))?.long_name ||
            addressComponents.find(c => c.types.includes("sublocality"))?.long_name;

        onSetCoordenadas({
            lat: results[0].geometry.location.lat(),
            lng: results[0].geometry.location.lng(),
            calle: streetName || '',
            numero: streetNumber || '',
            localidad: city || '',
            cod: postalCode || '',
        });
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter" && latLngMatch) {
            e.preventDefault();
            handleSelectLatLng(parseFloat(latLngMatch[1]), parseFloat(latLngMatch[2]));
        }
    };

    const renderSuggestions = () =>
        data.map((suggestion, index) => {
            const { place_id, structured_formatting: { main_text, secondary_text } } = suggestion;
            if (index < 3) {
                return (
                    <MenuItem
                        key={place_id}
                        onClick={handleSelect(suggestion)}
                        style={{ fontFamily: "Roboto", listStyleType: "none" }}
                    >
                        <strong>{main_text}, </strong>&nbsp;
                        <small>{secondary_text}</small>
                    </MenuItem>
                );
            }
            return null;
        });

    return (
        <div className={classes.searchBoxContainer}>
            <input
                value={value}
                onChange={handleInput}
                onKeyDown={handleKeyDown}
                disabled={!ready}
                className={classes.searchBox}
                placeholder="Buscar dirección, lugar o coordenadas (-34.123, -58.456)..."
            />
            {latLngMatch && (
                <ul style={{ paddingLeft: "0" }}>
                    <MenuItem
                        onClick={() => handleSelectLatLng(parseFloat(latLngMatch[1]), parseFloat(latLngMatch[2]))}
                        style={{ fontFamily: "Roboto", listStyleType: "none" }}
                    >
                        <strong>Ir a coordenadas:</strong>&nbsp;
                        <small>{latLngMatch[1]}, {latLngMatch[2]}</small>
                    </MenuItem>
                </ul>
            )}
            {!latLngMatch && status === "OK" && (
                <ul style={{ paddingLeft: "0" }}>{renderSuggestions()}</ul>
            )}
        </div>
    );
}
